import { Plus } from "lucide-react";
import { columns } from "./columns";
import { useNavigate } from "react-router-dom";
import { Heading } from "../../ui/heading";
import { Separator } from "../../ui/separator";
import { Button } from "../../ui/button";
import { DataTable } from "../../ui/data-table";

export const BudgetData: React.FC<any> = ({ data }) => {
  const router = useNavigate();

  return (
    <>
      <div className="flex items-start justify-between">
        <Heading
          title={`Budgets (${data.length})`}
          description="Gestion de la budgets "
        />
        <Button
          className="text-xs md:text-sm"
          onClick={() => router(`/admin-dashboard/budget/ajouter`)}
        >
          <Plus className="w-4 h-4 mr-2" /> Ajouter
        </Button>
      </div>
      <Separator />
      <DataTable searchKey="title" columns={columns} data={data} />
    </>
  );
};
